import { render, staticRenderFns } from "./service_factory.vue?vue&type=template&id=3244d24a&scoped=true"
import script from "./service_factory.vue?vue&type=script&lang=js"
export * from "./service_factory.vue?vue&type=script&lang=js"
import style0 from "./service_factory.vue?vue&type=style&index=0&id=3244d24a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3244d24a",
  null
  
)

export default component.exports